<template>
  <div class="error__box" v-show="isShow">
    <div class="error"
      v-for="(message, index) of messages"
      :key="index">
      <div class="error__text" v-if="message">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'

interface CsvApiErrorResponse {
  response: {
    data: {
      message: string | {
        item?: string,
        index: number,
        code: number,
        message: string,
      }[]
    }
  }
}

@Component
export default class ErrorCsv extends Vue {
  @Prop() errorMessages?: Error|string|CsvApiErrorResponse

  private get isShow(): boolean {
    if (_.isEmpty(this.errorMessages)) {
      return false
    }
    if (!this.errorMessages) {
      return false
    }
    return true
  }

  private get messages(): string[] {
    const error = this.errorMessages
    if (_.has(error, 'response')) {
      // APIレスポンスの場合
      const messages = _.get(error, 'response.data.message')
      if (!_.isArray(messages)) {
        // messageレスポンスが配列出ない場合はそのまま出力
        return [messages]
      }

      // messageレスポンスが配列の場合は取り出して出力
      return _.map(messages, ({ item, index, message }) => {
        if (_.isNull(item)) {
          return `row ${index} has error: ${message}`
        }
        return `${item} - row ${index} has error: ${message}`
      })
    }

    if (_.isArray(error)) {
      // 配列の場合は文字列のみ取り出して表示
      return _.filter(error, _.isString)
    }

    if (error instanceof Error) {
      // エラーの場合はメッセージを表示
      return [error.message]
    }

    if (typeof error === 'string') {
      // 文字列の場合はそのまま表示
      return [error]
    }

    return ['Has Error']
  }
}
</script>

<style scoped>
.error__box {
  overflow-y: auto;
  max-height: 490px;
  padding: 10px;
}

.error{
  margin: 25px 0px;
}

.error__text {
  background-color: rgba(250, 232, 232, 0.4);
  border-radius: 5px;
  padding: 15px;
  border: solid #f59696;
  border-width: 1px;
}

::-webkit-scrollbar{
  width: 10px;
}

::-webkit-scrollbar-track{
  background: rgb(238, 238, 238);
  border: none;
  border-radius: 10px;
  box-shadow: inset 0 0 2px rgb(221, 221, 221);
}

::-webkit-scrollbar-thumb{
  background: #ccc;
  border-radius: 10px;
  box-shadow: none;
}
</style>
